<template>
<div class="chapter">
<div class="inner_page">
<p class="image-center_wb"><img alt="image" class="svg" src="WBad/WBlogo.png"/></p>
<p class="end-title_wb">Sign up for our<br/>newsletter to discover<br/>more ebooks worth<br/>reading.</p>
<p class="image-center_wb1"><a href="http://worthbooks.com/subscribe/?utm_medium=frontad&amp;utm_source=worthbooks&amp;utm_campaign=ISBN" target="_blank"><img alt="image" class="svg" src="WBad/WBsignup.png"/></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// WBNewsletter.vue?60a25752